import { render, staticRenderFns } from "./Multimedia.vue?vue&type=template&id=f52bd6fa&scoped=true&"
import script from "./Multimedia.vue?vue&type=script&lang=js&"
export * from "./Multimedia.vue?vue&type=script&lang=js&"
import style0 from "./Multimedia.vue?vue&type=style&index=0&id=f52bd6fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52bd6fa",
  null
  
)

export default component.exports